
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21 13.5V19a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h5.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v14h14v-5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5zm-.22-10l-.27-.27A.75.75 0 0020 3h-6.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h4.09l-8.44 8.44a.5.5 0 000 .71l.7.7a.5.5 0 00.71 0L19 6.42v4.08a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V4a.75.75 0 00-.22-.51v.01z"}})])
          )
        }
      }
    